// src/hooks/useCurrentLang.js
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { SUPPORTED_LANGS, DEFAULT_LANG } from "../config/i18n";

export const useCurrentLang = () => {
  const { lang } = useParams(); // no generic in JS
  const navigate = useNavigate();

  const currentLang =
    lang && SUPPORTED_LANGS.includes(lang) ? lang : DEFAULT_LANG;

  useEffect(() => {
    if (lang && !SUPPORTED_LANGS.includes(lang)) {
      navigate(`/${DEFAULT_LANG}`, { replace: true });
    }
  }, [lang, navigate]);

  return currentLang;
};
